import React, { useEffect, useRef } from 'react';
import { GradientText } from '/src/components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './card-text.styles.scss';

const CardText = ({
  heading,
  subheading,
  bottomText,
  items = [],
  className = '',
  headingVariant = 'blue',
  subheadingVariant = 'lightGrey',
  bottomTextVariant = 'lightGrey',
  dividerColor = 'blue'
}) => {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);

  // Clear refs on each render
  itemRefs.current = [];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);

      // Set up animation after a brief delay to ensure refs are populated
      const timer = setTimeout(() => {
        if (itemRefs.current.length > 0) {
          gsap.fromTo(
            itemRefs.current,
            {
              opacity: 0,
              y: 30,
              scale: 0.95
            },
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.8,
              stagger: 0.15,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: containerRef.current,
                start: 'top 80%',
                toggleActions: 'play none none reverse'
              }
            }
          );
        }
      }, 100);

      return () => {
        clearTimeout(timer);
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
    }
  }, [items]);

  const addToRefs = (el) => {
    if (el && !itemRefs.current.includes(el)) {
      itemRefs.current.push(el);
    }
  };
  return (
    <div ref={containerRef} className={`card-text-container ${className}`}>
      {(heading || subheading) && (
        <div className="card-text-header">
          {heading && (
            <GradientText variant={headingVariant} className="card-text-heading fs-h2">
              {heading}
            </GradientText>
          )}
          {subheading && (
            <GradientText variant={subheadingVariant} className="fs-p">
              {subheading}
            </GradientText>
          )}
        </div>
      )}

      {items.length > 0 && (
        <div className="card-text-grid" data-item-count={items.length}>
          {items.map((item, index) => (
            <div key={index} ref={addToRefs} className="card-text-item">
              <div className={`card-text-divider card-text-divider--${dividerColor}`}></div>
              <h3 className="card-text-item-title fs-h6">{item.title}</h3>
              <div className="card-text-item-description fs-p">{item.description}</div>
            </div>
          ))}
        </div>
      )}

      {bottomText && (
        <div className="card-text-footer">
          <GradientText variant={bottomTextVariant} className="fs-p">
            {bottomText}
          </GradientText>
        </div>
      )}
    </div>
  );
};

export default CardText;
